import { getActiveRestaurantId } from "../utils/activeRestaurant";
import { useEffect, useState } from "react";
import { getOrdersByFilter } from "../services/order";
import { ILoginInfo } from "../models/ILoginInfo";
import { decrypt } from "../utils/Util";
import { IOrders } from "../models/IOrders";
import OrderListView from "./OrderListView";
import OrderFilterBar from "./OrderFilterBar";

// ─── Prop Tipi ───────────────────────────────────────────────────────────────
// restaurantId verilirse onu kullanır, verilmezse localStorage'dan okur.
// Böylece farklı sayfalardan da çağrılabilir:
//   <OrdersByDate />                          ← localStorage'dan restoran alır
//   <OrdersByDate restaurantId="abc-123" />   ← direkt ID verilir
interface OrdersByDateProps {
  restaurantId?: string;
}

// ─── Yardımcı: Varsayılan Tarih Aralığı ─────────────────────────────────────
const defaultStartDate = () => new Date(new Date().setDate(new Date().getDate() - 1));
const defaultEndDate   = () => new Date(new Date().setDate(new Date().getDate() + 1));

function OrdersByDate({ restaurantId: propRestaurantId }: OrdersByDateProps) {

  // ── State ──────────────────────────────────────────────────────────────────
  const [restaurantId, setRestaurantId] = useState<string>(propRestaurantId ?? '');
  const [startDate,    setStartDate]    = useState<Date>(defaultStartDate());
  const [endDate,      setEndDate]      = useState<Date>(defaultEndDate());
  const [orderList,    setOrderList]    = useState<IOrders | undefined>();
  const [loading,      setLoading]      = useState(false);
  const [errorMsg,     setErrorMsg]     = useState<string | null>(null);

  // ── Eğer prop gelmemişse localStorage'dan restoran ID'sini al ─────────────
  useEffect(() => {
    if (propRestaurantId) return; // prop varsa gerek yok
    const userJson = localStorage.getItem("user");
    if (userJson) {
      const encUser: ILoginInfo = JSON.parse(decrypt(userJson));
      if (getActiveRestaurantId()) setRestaurantId(getActiveRestaurantId());
    }
  }, [propRestaurantId]);

  // ── Restoran ID hazır olunca siparişleri getir ─────────────────────────────
  useEffect(() => {
    if (restaurantId) fetchOrders(restaurantId, startDate, endDate);
  }, [restaurantId]);

  // ── API İsteği ─────────────────────────────────────────────────────────────
  const fetchOrders = (rId: string, start: Date, end: Date) => {
    if (!rId) return;
    setLoading(true);
    setErrorMsg(null);
    setOrderList(undefined);
    getOrdersByFilter({ RestaurantId: rId, StartDate: start, EndDate: end })
      .then((res) => { if (res.data) setOrderList(res.data); })
      .catch((err) => {
        const desc = err?.response?.data?.[0]?.description
                  ?? err?.response?.data?.description;
        setErrorMsg(desc ?? 'Bu tarih aralığında sipariş bulunamadı.');
      })
      .finally(() => setLoading(false));
  };

  // ── Filtre Formu Submit ────────────────────────────────────────────────────
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    fetchOrders(restaurantId, startDate, endDate);
  };

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <div className="container-fluid py-3">

      {/* Başlık */}
      <div className="d-flex align-items-center mb-4">
        <div style={{ width: '5px', height: '32px', background: '#3b82f6', borderRadius: '4px', marginRight: '12px' }} />
        <h4 className="mb-0 fw-bold" style={{ color: '#1e293b' }}>
          <i className="bi bi-receipt-cutoff me-2 text-primary"></i>
          Siparişler
        </h4>
        {orderList && (
          <span className="badge ms-3" style={{ background: '#eff6ff', color: '#1d4ed8', fontSize: '0.78rem', borderRadius: '20px', padding: '4px 12px' }}>
            {orderList.orderList.length} sipariş
          </span>
        )}
      </div>

      {/* Tarih Filtresi */}
      <OrderFilterBar
        startDate={startDate}
        endDate={endDate}
        loading={loading}
        onStartDateChange={setStartDate}
        onEndDateChange={setEndDate}
        onSearch={handleSearch}
      />

      {/* Hata / Boş Durum */}
      {errorMsg && (
        <div
          className="d-flex align-items-center gap-2 rounded-3 px-4 py-3"
          style={{ background: '#fff7ed', border: '1.5px solid #fed7aa', color: '#92400e', fontSize: '0.9rem' }}
        >
          <i className="bi bi-inbox fs-5"></i>
          <span>{errorMsg}</span>
        </div>
      )}

      {/* Sipariş Listesi */}
      {orderList && <OrderListView OrderList={orderList} />}

    </div>
  );
}

export default OrdersByDate;